export default __webpack_public_path__ + "static/media/download-03.850d6ec2.svg";